import { render, staticRenderFns } from "./VListItemWrapper.vue?vue&type=template&id=f4fc73f0"
import script from "./VListItemWrapper.vue?vue&type=script&lang=js"
export * from "./VListItemWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports